export default __webpack_public_path__ + "static/media/cb-place-order-d.146776d3.jpg";